import { createContext, Context } from 'react';
import type { Config } from './types';

export const ConfigContext: Context<Config | null> = createContext(null);
ConfigContext.displayName = 'ConfigContext';
